import {
    Formik,
    Form as FormikForm,
} from 'formik';

export function Form(props) {
    return (
        <Formik
            {...props}
        >

            {/* noValidate must be a boolean — `noValidate=""` is falsy in React, so the
                attribute never rendered and the browser's own "Please fill out this field"
                popup fired before Formik/Yup validation could show its own message. */}
            <FormikForm className="needs-validation" noValidate>
                {props.children}
            </FormikForm>
           
        </Formik>)
}

export default Form;